import { createThunkEffect } from '../../utilities/ActionUtility';
import IStore from '../../models/IStore';
import HttpErrorResponseModel from '../../models/HttpErrorResponseModel';
import { ReduxDispatch } from '../../models/ReduxProps';
import InitBackendEffect from '../effects/initBackendEffect';


type InitActionUnion =
  void
  | HttpErrorResponseModel
  | string;

export default class InitBackendActions {
public static readonly REQUEST_GET_INIT = 'InitBackendActions.REQUEST_POST_INIT';
public static readonly REQUEST_GET_INIT_FINISHED = 'InitBackendActions.REQUEST_POST_INIT_FINISHED';

 public static getInit = ():any => {
  return async (dispatch: ReduxDispatch<InitActionUnion>, getState: () => IStore) => {
    return createThunkEffect<String>(
      dispatch,
      getState(),
      InitBackendActions.REQUEST_GET_INIT,
      InitBackendEffect.getInitEffect,
    );
  };
};

}